import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import Api from "../../../../Services/Api";
import {
  GenericSequenceType,
  HttpStatus,
  Status,
} from "../../../common/Constants";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToObjectDDL,
} from "../../../common/mapper";
import DataKonsumenInputs from "../common/dataKonsumenInputs";
import InfoUnitInputs from "../common/infoUnitInputs";
import IndentUnitBelumProsesDataCustomer from "./indentUnitBelumProsesDataCustomer";
import IndentUnitBelumProsesDataProspek from "./indentUnitBelumProsesDataProspek";
import ErrorAction from "../../../../Redux/ErrorRedux";
import M from "moment/moment";
import { fetchDataAsync } from "../../../../Services/Utils";

class IndentUnitBelumProsesModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      successSaveVisible: false,
      confirmCancelIndent: false,
      confirmClearForm: false,
      dataCustomerVisible: false,
      dataProspekVisible: false,
      provinceOptions: [],
      kotaOptions: [],
      kelurahanOptions: [],
      kecamatanOptions: [],
      kodeVarianOptions: [],
      planOptions: [],
      warnaOptions: [],
      zipCodeOptions: [],
      cancelReason: "",
      errorTandaJadi: null,
      errorCancelReason: null,
      varianInformation: {
        name: "-",
        type: "-",
        series: "-",
      },
    };
  }

  async componentDidMount() {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    if (this.props.detail.id) {
      const response = await Api.create(
        "NAGAMAS_TRANSACTION"
      ).getIndentUnitDetail(this.props.kodeCabang, this.props.detail.id);
      if (!response.ok) {
        this.props.onClickClose("");
        return;
      }

      const data = response.data.data;
      this.setInitialFieldValue(data);
    } else {
      let indentNo = await this.fetchDataGenerateSeq({
        seqType: GenericSequenceType.TRANSACTION_INDENT_UNIT,
        nosDealerCode: this.props.kodeCabang,
        transactionType: GenericSequenceType.TRANSACTION_INDENT_UNIT,
      });
      this.props.setValue("indentNo", indentNo);
    }

    const responses = await Promise.all([
      Api.create("NAGAMAS_MASTER_DATA").getAllProvince(),
      Api.create("NAGAMAS_MASTER_DATA").getAllVariant(),
      Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
        paramFilters: {
          bizparCategory: "PAYMENT_TYPE_INDENT_UNIT",
          status: Status.ACTIVE,
        },
      }),
    ]);
    if (responses[0].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        provinceOptions: responses[0].data.data.map((option) =>
          mapToObjectDDL(option.provinceName, option.id)
        ),
      }));
    }

    if (responses[1].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kodeVarianOptions: responses[1].data.data.map((kv) => ({
          label: kv.kodeVariant,
          value: kv.kodeVariant,
          name: kv.namaVariant,
          type: kv.typeName,
          series: kv.kodeUnitPabrik,
        })),
      }));
    }

    if (responses[2].ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        planOptions: responses[2].data.data.map((p) =>
          mapToObjectDDL(p.value, p.value)
        ),
      }));
    }
    this.setState((prevValue) => ({ ...prevValue, loading: false }));
  }

  fetchKotaOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllCity(id);
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kotaOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kabKotName, option.kabKotId)
        ),
      }));
    }
  };

  fetchKecamatanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan(
      id
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kecamatanOptions: response.data.data.map((option) =>
          mapToObjectDDL(option.kecamatanName, option.id)
        ),
      }));
    }
  };

  fetchKelurahanOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan(
      id
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        kelurahanOptions: response.data.data.map((option) => ({
          ...mapToObjectDDL(option.kelurahanname, option.id),
        })),
      }));
    }
  };

  fetchZipCodeOptions = async (id) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getKelurahanById(
      id
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        zipCodeOptions: [
          mapToObjectDDL(
            response.data.data.zipcode,
            response.data.data.zipcode
          ),
        ],
      }));
    }
  };

  fetchWarnaOptions = async (value) => {
    const response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam(
      {
        paramFilters: {
          kodeVariant: value.value,
        },
      }
    );
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        warnaOptions: response.data.data.map((w) =>
          mapToObjectDDL(w.namaWarnaPabrik, w.id)
        ),
      }));
    }
  };

  handleChangeProvince = async (name, value) => {
    this.props.setValue("customerKabKotId", null);
    this.props.setValue("customerKecamatanId", null);
    this.props.setValue("customerZipCode", null);
    this.props.setValue(name, value);
    if (value) {
      this.fetchKotaOptions(value.value);
    }
  };

  handleChangeKota = async (name, value) => {
    this.props.setValue("customerKecamatanId", null);
    this.props.setValue("customerZipCode", null);
    this.props.setValue(name, value);
    if (value) {
      this.fetchKecamatanOptions(value.value);
    }
  };

  handleChangeKecamatan = async (name, value) => {
    this.props.setValue("customerKelurahanId", null);
    this.props.setValue(name, value);
    if (value) {
      this.fetchKelurahanOptions(value.value);
    }
  };

  handleChangeKelurahan = async (name, value) => {
    this.props.setValue("customerZipCode", null);
    this.props.setValue(name, value);
    if (value) {
      this.fetchZipCodeOptions(value.value);
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.props.validate()) {
      this.setState((prevValue) => ({ ...prevValue, loading: true }));
      const { memberID, noProspek, ...formGroup } = flattenFormGroupObject(
        this.props.controls
      );
      if (this.props.controls.indentDeposit.value === "Y") {
        let amount = formGroup.totalDepositAmount
          ? parseInt(formGroup.totalDepositAmount)
          : 0;
        let error =
          amount <= 0 ? "Field belum diisi dan harus lebih besar dari 0" : null;
        this.setState((prevValue) => ({
          ...prevValue,
          errorTandaJadi: error,
          loading: false,
        }));
        if (error) return;
      }
      const request = {
        ...formGroup,
        customerMemberId: memberID,
        prospectId: noProspek,
        idUserSeller: this.props.idUser,
        kodeCabang: this.props.kodeCabang,
        customerKelurahanId: getValueFromDDL(formGroup, "customerKelurahanId"),
        customerKabKotId: getValueFromDDL(formGroup, "customerKabKotId"),
        customerKecamatanId: getValueFromDDL(formGroup, "customerKecamatanId"),
        customerProvinceId: getValueFromDDL(formGroup, "customerProvinceId"),
        customerZipCode: getValueFromDDL(formGroup, "customerZipCode"),
        idWarna: getValueFromDDL(formGroup, "idWarna"),
        paymentPlan: getValueFromDDL(formGroup, "paymentPlan") || null,
        variantCode: getValueFromDDL(formGroup, "variantCode"),
        indentDeposit: formGroup.indentDeposit
          ? formGroup.indentDeposit === "Y"
          : false,
        totalDepositAmount: formGroup.totalDepositAmount
          ? parseInt(formGroup.totalDepositAmount)
          : 0,
      };
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").modifyIndentUnit,
        menuName: "Inden Unit - Belum Proses",
        setError: this.props.setError,
        args: request,
      });
      if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        this.handleSuccessSaveVisibility();
      }

      this.setState((prevValue) => ({ ...prevValue, loading: false }));
    }
  };

  handleInput = (name, value) => {
    this.props.setValue(name, typeof value === "object" ? value : value.toUpperCase());
  };

  handleChangeVarian = async (value, { name }) => {
    this.props.setValue("idWarna", null);
    this.props.setValue(name, value);
    this.setState((prevValue) => ({
      ...prevValue,
      varianInformation: {
        name: value.name,
        type: value.type,
        series: value.series,
      },
    }));
    if (value) {
      this.fetchWarnaOptions(value);
    }
  };

  handleDataProspekVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataProspekVisible: !prevValue.dataProspekVisible,
    }));
  };

  handleDataCustomerVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      dataCustomerVisible: !prevValue.dataCustomerVisible,
    }));
  };

  handleConfirmIndentVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      cancelReason: "",
      confirmCancelIndent: !prevValue.confirmCancelIndent,
    }));
  };

  handleCancelIndent = async () => {
    if(!this.state.cancelReason) {
      return this.setState({errorCancelReason: "Field belum diisi"})
    }else{
      this.setState({ errorCancelReason: null})
    }
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    try {
      const controls = this.props.controls;
      const request = {
        indentNo: controls.indentNo.value,
        kodeCabang: this.props.kodeCabang,
        indentReasonCancelled: this.state.cancelReason,
        indentDateCancelled: M(new Date()).format("DD-MM-YYYY"),
        indentUserCancelled: this.props.idUser,
      };
      await Api.create("NAGAMAS_TRANSACTION").cancelIndentUnit(request);
    } catch (error) {
      this.props.setError({
        menuName: "Indent Unit Belum Proses",
        errorMessage: error.message,
      });
    }
    this.setState((prevValue) => ({ ...prevValue, loading: false }));
    this.props.onClickClose(null);
  };

  setInitialFieldValue = (data) => {
    this.props.setValue("indentNo", data?.indentNo);
    this.props.setValue("noProspek", data?.prospectId || null);
    this.props.setValue("memberID", data?.customerMemberId || null);
    this.props.setValue("kodeCabang", data?.kodeCabang);
    this.props.setValue("indentDate", data?.indentDate);
    this.props.setValue("customerName", data?.customerName);
    this.props.setValue("customerKTPNumber", data?.customerKTPNumber);
    this.props.setValue("customerHpNumber", data?.customerHpNumber);
    this.props.setValue("customerWaNumber", data?.customerWaNumber);
    this.props.setValue("email", data?.email);
    this.props.setValue("customerAddress", data?.customerAddress);
    this.props.setValue(
      "customerProvinceId",
      data?.dataProvinceCustomer &&
        mapToObjectDDL(
          data.dataProvinceCustomer.provinceName,
          data.dataProvinceCustomer.id
        )
    );

    if (data?.dataKabKotCustomer) {
      this.props.setValue(
        "customerKabKotId",
        mapToObjectDDL(
          data.dataKabKotCustomer.kabKotName,
          data.dataKabKotCustomer.kabKotId
        )
      );
      this.fetchKotaOptions(data.dataKabKotCustomer.idProvince);
    }

    if (data?.dataKecamatanCustomer) {
      this.props.setValue(
        "customerKecamatanId",
        mapToObjectDDL(
          data.dataKecamatanCustomer.kecamatanName,
          data.dataKecamatanCustomer.id
        )
      );
      this.fetchKecamatanOptions(data.dataKecamatanCustomer.idKabKot);
    }

    if (data?.dataKelurahanCustomer) {
      this.props.setValue("customerKelurahanId", {
        ...mapToObjectDDL(
          data?.dataKelurahanCustomer.kelurahanname,
          data?.dataKelurahanCustomer.id
        ),
        kelurahanId: data?.dataKelurahanCustomer.id,
      });
      this.fetchKelurahanOptions(data.dataKelurahanCustomer.idkecamatan);
    }

    if (data?.customerZipCode) {
      this.props.setValue("customerZipCode", {
        ...mapToObjectDDL(data?.customerZipCode, data?.customerZipCode),
      });
      if (data?.dataKelurahanCustomer) {
        this.fetchZipCodeOptions(data?.dataKelurahanCustomer.id);
      }
    }

    if (data?.dataVarian) {
      this.props.setValue(
        "variantCode",
        mapToObjectDDL(data.dataVarian.kodeVariant, data.dataVarian.kodeVariant)
      );
      this.setState((prevValue) => ({
        ...prevValue,
        varianInformation: {
          name: data.dataVarian.namaVariant,
          type: data.dataVarian?.typeDTO?.typeName,
          series: data.dataVarian.kodeUnitPabrik,
        },
      }));
      this.fetchWarnaOptions(data.dataVarian.kodeVariant);
    }

    this.props.setValue(
      "idWarna",
      data?.dataWarna &&
        mapToObjectDDL(data.dataWarna.namaWarnaKomersil, data.dataWarna.id)
    );

    this.props.setValue(
      "paymentPlan",
      data?.paymentPlan && mapToObjectDDL(data.paymentPlan, data.paymentPlan)
    );
    this.props.setValue("indentDeposit", data?.indentDeposit ? "Y" : "N");
    this.props.setValue("totalDepositAmount", data?.totalDepositAmount);
  };

  handleConfirmClearVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      confirmClearForm: !prevValue.confirmClearForm,
    }));
  };

  handleDataProspek = (value) => {
    this.props.setValue("customerZipCode", null);
    this.props.setValue("customerName", value?.memberName?.toUpperCase());
    this.props.setValue("customerKTPNumber", value?.memberNIK?.toUpperCase());
    this.props.setValue("customerWaNumber", value?.noHandphone?.toUpperCase());
    this.props.setValue("customerHpNumber", value?.noHandphone?.toUpperCase());
    this.props.setValue("email", value?.email?.toUpperCase());
    this.props.setValue("customerAddress", value?.address?.toUpperCase());
    this.props.setValue("memberID", value?.memberId?.toUpperCase());
    this.props.setValue("noProspek", value?.noProspek?.toUpperCase());
    if (value?.provinsiDTO) {
      this.props.setValue(
        "customerProvinceId",
        mapToObjectDDL(value?.provinsiDTO?.provinceName, value?.provinsiDTO?.id)
      );
      this.fetchKotaOptions(value?.provinsiDTO?.id);
    }
    if (value?.kabKotDTO) {
      this.props.setValue(
        "customerKabKotId",
        mapToObjectDDL(value?.kabKotDTO?.kabKotName, value?.kabKotDTO?.kabKotId)
      );
      this.fetchKecamatanOptions(value?.kabkotDTO?.kabKotId);
    }
    if (value?.kecamatanDTO) {
      this.props.setValue(
        "customerKecamatanId",
        mapToObjectDDL(
          value?.kecamatanDTO?.kecamatanName,
          value?.kecamatanDTO?.id
        )
      );
      this.fetchKelurahanOptions(value?.kecamatanDTO?.id);
    }
    if (value?.kelurahanDTO) {
      this.props.setValue(
        "customerKelurahanId",
        mapToObjectDDL(
          value?.kelurahanDTO?.kelurahanname,
          value?.kelurahanDTO?.id
        )
      );
      this.fetchKelurahanOptions(value?.kelurahanDTO?.id);
      this.fetchZipCodeOptions(value?.kelurahanDTO?.id);
    }
  };

  handleDataCustomer = (value) => {
    this.props.setValue("customerZipCode", null);
    this.props.setValue("customerName", value?.memberName?.toUpperCase());
    this.props.setValue("customerKTPNumber", value?.memberNIK?.toUpperCase());
    this.props.setValue("customerWaNumber", value?.noHandphone?.toUpperCase());
    this.props.setValue("customerHpNumber", value?.noHandphone?.toUpperCase());
    this.props.setValue("email", value?.email?.toUpperCase());
    this.props.setValue("customerAddress", value?.address?.toUpperCase());
    this.props.setValue("memberID", value?.memberId?.toUpperCase());
    if (value?.provinsiDTO) {
      this.props.setValue(
        "customerProvinceId",
        mapToObjectDDL(value?.provinsiDTO?.provinceName, value?.provinsiDTO?.id)
      );
      this.fetchKotaOptions(value?.provinsiDTO?.id);
    }
    if (value?.kabKotDTO) {
      this.props.setValue(
        "customerKabKotId",
        mapToObjectDDL(value?.kabKotDTO?.kabKotName, value?.kabKotDTO?.kabKotId)
      );
      this.fetchKecamatanOptions(value?.kabkotDTO?.kabKotId);
    }
    if (value?.kecamatanDTO) {
      this.props.setValue(
        "customerKecamatanId",
        mapToObjectDDL(
          value?.kecamatanDTO?.kecamatanName,
          value?.kecamatanDTO?.id
        )
      );
      this.fetchKelurahanOptions(value?.kecamatanDTO?.id);
    }
    if (value?.kelurahanDTO) {
      this.props.setValue(
        "customerKelurahanId",
        mapToObjectDDL(
          value?.kelurahanDTO?.kelurahanname,
          value?.kelurahanDTO?.id
        )
      );
      this.fetchKelurahanOptions(value?.kelurahanDTO?.id);
      this.fetchZipCodeOptions(value?.kelurahanDTO?.id);
    }
     if (value?.kelurahanDTO) {
       this.props.setValue(
        "customerZipCode",
        mapToObjectDDL(
          value?.kelurahanDTO?.zipcode,
          value?.kelurahanDTO?.zipcode
        )
      );
      this.fetchZipCodeOptions(value?.kelurahanDTO?.id);
    }
  };

  fetchDataGenerateSeq = async (body) => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(
        body
      );
      if (res.ok) {
        return res.data;
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  handleSuccessSaveVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      successSaveVisible: !prevValue.successSaveVisible,
    }));
  };

  render() {
    return (
      <>
        <SimpleModal
          title={`Indent Unit Detail - ${
            this.props.detail.id ? "Edit" : "Tambah Data"
          }`}
          visible={this.props.detail.visible}
          onClickClose={() => this.props.onClickClose("")}
          content={
            <ModalContainer>
              <form onSubmit={this.handleSubmit}>
                <div className="grid grid-2x grid-mobile-none gap-15px">
                  <div id="form_grid-1">
                    <SimpleInput
                      id="input_text_no_indent"
                      readOnly
                      label="No. Indent"
                      name="indentNo"
                      value={this.props.controls.indentNo.value}
                    />
                    <div
                      style={{ display: "flex", alignItems: "end", gap: "7px" }}
                    >
                      <SimpleInput
                        id="input_text_no_prospek"
                        label="No. Prospek"
                        name="noProspek"
                        readOnly
                        containerclassname="flex-1"
                        value={this.props.controls.noProspek.value}
                        // onChange={({ target }) => this.handleInput(target.name, target.value)}
                      />
                      <SimpleButton
                        type="button"
                        category="action_button"
                        className="btn margin-bottom-20px"
                        styles={{ border: "1px solid rgba(0, 0, 0, 0.1)" }}
                        icon={<i className="fa fa-search"></i>}
                        onClick={this.handleDataProspekVisibility}
                      />
                    </div>
                  </div>
                  <div id="form_grid-2">
                    <SimpleDate
                      id="select_date_tgl_indent"
                      disabled
                      date={this.props.controls.indentDate.value}
                      name="indentDate"
                      label="Tgl. Indent"
                    />
                  </div>
                </div>
                <hr
                  style={{
                    height: "1px",
                    background: "gray",
                    marginBottom: "15px",
                  }}
                />
                <div className="grid grid-2x grid-mobile-none gap-15px">
                  <div id="form_data-grid-1">
                    <DataKonsumenInputs
                      state={this.state}
                      errors={this.props.errors}
                      data={{
                        customerName: this.props.controls.customerName.value,
                        memberID: this.props.controls.memberID.value,
                        customerKTPNumber:
                          this.props.controls.customerKTPNumber.value,
                        customerHpNumber:
                          this.props.controls.customerHpNumber.value,
                        customerWaNumber:
                          this.props.controls.customerWaNumber.value,
                        email: this.props.controls.email.value,
                        customerProvinceId:
                          this.props.controls.customerProvinceId.value,
                        customerAddress:
                          this.props.controls.customerAddress.value,
                        customerKabKotId:
                          this.props.controls.customerKabKotId.value,
                        customerKecamatanId:
                          this.props.controls.customerKecamatanId.value,
                        customerKelurahanId:
                          this.props.controls.customerKelurahanId.value,
                        customerZipCode:
                          this.props.controls.customerZipCode.value,
                      }}
                      onChangeInput={this.handleInput}
                      onChangeProvince={this.handleChangeProvince}
                      onChangeKota={this.handleChangeKota}
                      onChangeKecamatan={this.handleChangeKecamatan}
                      onChangeKelurahan={this.handleChangeKelurahan}
                      onClickDataCustomer={this.handleDataCustomerVisibility}
                    />
                  </div>
                  <div id="form_data-grid-2">
                    <InfoUnitInputs
                      state={this.state}
                      errors={this.props.errors}
                      data={{
                        variantCode: this.props.controls.variantCode.value,
                        idWarna: this.props.controls.idWarna.value,
                      }}
                      onChangeVarian={this.handleChangeVarian}
                      onChangeWarna={(value, { name }) =>
                        this.props.setValue(name, value)
                      }
                    />
                    <div>
                      <h4>Pembayaran (Optional)</h4>
                      <SimpleDDL
                        id="select_options_rencana_pembayaran"
                        name="paymentPlan"
                        box="search"
                        label="Rencana Pembayaran Pembelian"
                        isClearable
                        mandatory
                        options={this.state.planOptions}
                        errorMessage={this.props.errors.paymentPlan}
                        value={this.props.controls.paymentPlan.value}
                        onChange={(value, { name }) =>
                          this.props.setValue(name, value)
                        }
                      />
                      <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                        <p>Tanda Jadi:</p>
                        <div>
                          <input
                            type="radio"
                            id="input_radio_yes"
                            name="indentDeposit"
                            value="Y"
                            checked={
                              this.props.controls.indentDeposit.value === "Y"
                            }
                            onChange={({ target }) =>
                              this.handleInput(target.name, target.value)
                            }
                          />
                          <label htmlFor="input_radio_yes">Ya</label>
                        </div>
                        <div>
                          <input
                            type="radio"
                            id="input_radio_no"
                            name="indentDeposit"
                            value="N"
                            checked={
                              this.props.controls.indentDeposit.value === "N"
                            }
                            onChange={({ target }) =>
                              this.handleInput(target.name, target.value)
                            }
                          />
                          <label htmlFor="input_radio_no">No</label>
                        </div>
                      </FlexView>
                      <FlexView vAlignContent="center">
                        <p>Jumlah Tanda Jadi:</p>
                        <p className="margin-left-10px margin-right-5px">Rp.</p>
                        <SimpleInput
                          id="input_text_jumlah_tanda_jadi"
                          name="totalDepositAmount"
                          box="onlyNumber"
                          mandatory={
                            this.props.controls.indentDeposit.value === "Y"
                              ? true
                              : false
                          }
                          containerclassname="margin-bottom-none"
                          value={
                            this.props.controls.indentDeposit.value === "N"
                              ? 0
                              : this.props.controls?.totalDepositAmount.value
                          }
                          readOnly={
                            this.props.controls.indentDeposit.value === "N"
                          }
                          onChange={({ target }) =>
                            this.handleInput(target.name, target.value)
                          }
                          errorMessage={this.state.errorTandaJadi}
                        />
                      </FlexView>
                    </div>
                  </div>
                </div>
                <FlexView
                  style={{
                    justifyContent: this.props.detail.id
                      ? "space-between"
                      : "right",
                    marginTop: "15px",
                  }}
                >
                  {this.props.detail.id && (
                    <SimpleButton
                      type="button"
                      onClick={this.handleConfirmIndentVisibility}
                    >
                      CANCEL INDENT
                    </SimpleButton>
                  )}
                  <div>
                    <SimpleButton
                      type="button"
                      text="Clear"
                      onClick={this.handleConfirmClearVisibility}
                    />
                    <SimpleButton text="Simpan" type="submit" />
                  </div>
                </FlexView>
              </form>
            </ModalContainer>
          }
        />
        {this.state.dataProspekVisible && (
          <IndentUnitBelumProsesDataProspek
            {...this.props}
            visible={this.state.dataProspekVisible}
            onClickClose={this.handleDataProspekVisibility}
            onChange={(value) => this.handleDataProspek(value)}
          />
        )}
        {this.state.dataCustomerVisible && (
          <IndentUnitBelumProsesDataCustomer
            {...this.props}
            visible={this.state.dataCustomerVisible}
            onClickClose={this.handleDataCustomerVisibility}
            onChange={(value) => this.handleDataCustomer(value)}
          />
        )}
        {this.state.confirmCancelIndent && (
          <SimpleAlert
            title="Warning!"
            visible={this.state.confirmCancelIndent}
            onClickClose={this.handleConfirmIndentVisibility}
            content={
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    textAlign: "left",
                  }}
                >
                  <p>
                    Anda akan membatalkan proses Indent Unit Konsumen. Proses
                    ini tidak bisa dirollback & harus input ulang. Apakah anda
                    yakin
                  </p>
                  <div>
                    <SimpleTextArea
                      label="Alasan Cancel"
                      id="input_text_alasan_cancel"
                      name="alasanCancel"
                      typeInputCase="normal"
                      mandatory
                      value={this.state.cancelReason}
                      errorMessage={this.state.errorCancelReason}
                      onChange={({ target }) =>
                        this.setState((prevValue) => ({
                          ...prevValue,
                          cancelReason: target.value?.toUpperCase(),
                        }))
                      }
                    />
                  </div>
                </div>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    className="margin-left-none"
                    secondary
                    onClick={this.handleConfirmIndentVisibility}
                  >
                    Batal
                  </SimpleButton>
                  <SimpleButton onClick={this.handleCancelIndent}>
                    Ya
                  </SimpleButton>
                </FlexView>
              </>
            }
          />
        )}
        {this.state.confirmClearForm && (
          <SimpleAlert
            title="Warning!"
            visible={this.state.confirmClearForm}
            onClickClose={this.handleConfirmClearVisibility}
            content={
              <p>
                Anda akan mengosongkan data pada semua field di form ini. Anda
                yakin?
              </p>
            }
            additionalButtons={
              <FlexView hAlignContent="right">
                <SimpleButton
                  className="margin-left-none"
                  text="Batal"
                  onClick={this.handleConfirmClearVisibility}
                />
                <SimpleButton
                  text="Ya"
                  onClick={() => {
                    this.props.resetIgnoreKeys(["indentNo", "indentDate"]);
                    this.handleConfirmClearVisibility();
                  }}
                />
              </FlexView>
            }
          />
        )}

        {this.state.successSaveVisible && (
          <SimpleAlert
            visible={this.state.successSaveVisible}
            title={"Information"}
            onClickClose={this.handleSuccessSaveVisibility}
            content={
              <div>
                <p>Data Indent berhasil disimpan.</p>
                <FlexView hAlignContent="center">
                  <SimpleButton
                    className="margin-top-15px"
                    text="OK"
                    onClick={() => {
                      this.props.onRefresh();
                      this.props.onClickClose(null);
                    }}
                  />
                </FlexView>
              </div>
            }
          />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    idUser: state.auth.user.idUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withFormGroup(IndentUnitBelumProsesModifying));
